import React from 'react';
import { HashRouter as Router } from 'react-router-dom';
import Header from './components/Header';
import Hero from './components/Hero';
import Services from './components/Services';
import About from './components/About';
import Gallery from './components/Gallery';
import Testimonials from './components/Testimonials';
import Contact from './components/Contact';
import Footer from './components/Footer';
import FloatingActions from './components/FloatingActions';
import './App.css';

function App() {
  return (
    <Router>
      <div className="min-h-screen bg-white font-sans selection:bg-blue-600 selection:text-white">
        <Header />
        <main>
          <Hero />
          <Services />
          <About />
          <Gallery />
          <Testimonials />
          <Contact />
        </main>
        <FloatingActions />
        <Footer />
      </div>
    </Router>
  );
}

export default App;